import { Link } from "react-router-dom";
import { href } from "../content/shared";
import { useT } from "../i18n";

const KEY = "cp-consent";
export const getConsent = () => (typeof window === "undefined" ? null : localStorage.getItem(KEY));

// Optional analytics are loaded here only after consent. No provider is configured yet.
export const loadOptionalScripts = () => {};

export default function CookieBanner({ open, onClose }) {
  const { lang, t } = useT();
  if (!open) return null;
  const choose = (v) => {
    localStorage.setItem(KEY, v);
    if (v === "accepted") loadOptionalScripts();
    onClose();
  };
  return (
    <div role="dialog" aria-live="polite" aria-label={t.cookie.title} className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-xl rounded-2xl border border-border bg-surface p-5 shadow-2xl md:left-auto md:right-6 md:bottom-6" data-testid="cookie-banner">
      <p className="font-display text-base font-semibold">{t.cookie.title}</p>
      <p className="mt-2 text-sm text-muted-foreground">
        {t.cookie.text} <Link to={href(lang, "privacy")} className="link">{t.cookie.policy}</Link>
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button type="button" className="btn-primary h-10" onClick={() => choose("accepted")} data-testid="cookie-accept">{t.cookie.accept}</button>
        <button type="button" className="btn-secondary h-10" onClick={() => choose("rejected")} data-testid="cookie-reject">{t.cookie.reject}</button>
      </div>
    </div>
  );
}
